import React from 'react';
import { withStyles } from "tss-react/mui";
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import SiteIcon from 'components/Icons/Site/Site';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import SiteSelectionDialog from 'areas/location/components/SiteSelectionDialog';
import styles from './styles';
import OutlinedTextField from 'components/OutlineTextField';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

class LocationPanel extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            siteDialogOpen: false
        };

        props.onDialogLoaded();

    }

    handlePartialSiteTextChanged = (e) => {

        if (e.target.value == null || e.target.value == "") {
            this.setState({
                visibleSites: []
            });
            return;
        }

        const projectsToList = [];
        if (this.props.projects != null) {
            Object.keys(this.props.projects).map((key) => (
                Object.keys(this.props.projects[key]).map((divisionkey) => (
                    projectsToList.push(this.props.projects[key][divisionkey])
                ))
            ));
        }

        const sitesToList = [];
        if (this.props.sites != null) {
            Object.keys(this.props.sites).map((key) => (
                Object.keys(this.props.sites[key]).map((sitekey) => (
                    sitesToList.push(this.props.sites[key][sitekey])
                ))
            ));
        }

        const partialSiteText = e.target.value.toLowerCase();
        const matchingSites = [];
        if (sitesToList != []) {
            Object.keys(sitesToList).map((key) => {
                if (sitesToList[key].name.toLowerCase().includes(partialSiteText) || sitesToList[key].siteCode.toLowerCase().includes(partialSiteText)) {
                    matchingSites.push(sitesToList[key])
                }
            });
        }

        this.setState({
            visibleSites: matchingSites,
            projectsToList : projectsToList
        });

    };

    handleSiteSelected = (site) => {
        this.props.onSiteSelected(site);
        this.setState({ siteDialogOpen: false });
    };

    handleZoneSelected = (site, zone) => {
        this.props.onZoneSelected(site, zone);
        this.setState({ siteDialogOpen: false });
    };

    render() {

        const {
            classes, 
            zones,
            divisionsLoading,
            divisionDataLoading } = this.props;

        const selectedProjectFromSite = (this.state.selectedSite && this.state.selectedSite.projectID) &&
                                        this.state.projectsToList.find(p => { return p.projectID === this.state.selectedSite.projectID });

        const zonesToList = (this.state.selectedSite && this.state.selectedSite.siteID) && zones ? zones[this.state.selectedSite.siteID] : null;

        return (
            <List>

                <SiteSelectionDialog
                    open={this.state.siteDialogOpen}
                    title={this.props.siteName + " Details"}
                    handleClose={() => this.setState({ siteDialogOpen: false })}
                    site={this.state.selectedSite}
                    project={selectedProjectFromSite}
                    zones={zonesToList}
                    displayProp="name"
                    itemIcon={
                        <ListItemAvatar>
                            <SiteIcon />
                        </ListItemAvatar>
                    }
                    onSiteSelected={this.handleSiteSelected}
                    onZoneSelected={this.handleZoneSelected}
                    zoneName={this.props.zoneName}
                    siteName={this.props.siteName}
                    siteID={this.props.siteID}
                    projectName={this.props.projectName}
                    divisionName={this.props.divisionName}
                                        />

                {!divisionsLoading && !divisionDataLoading &&
                    <React.Fragment>

                        <div className={classes.panel}>
                            <OutlinedTextField
                                id="partialSiteText"
                                autoFocus
                                fullWidth
                                name="partialSiteText"
                                autoComplete="off"
                                placeholder="Enter site name or site code"
                                onKeyUp={this.handlePartialSiteTextChanged}
                            />

                            <Divider />

                            <List>
                                {this.state.visibleSites && this.state.visibleSites.map((item, index) =>
                                    <React.Fragment key={index}>
                                        <ListItem button onClick={() => this.setState({ siteDialogOpen: true, selectedSite: item })}>
                                            <ListItemText>{item.name}<br/>{item.siteCode}</ListItemText>
                                        </ListItem>
                                        <Divider />
                                    </React.Fragment>
                                )}
                            </List>
                            
                        </div>
                    </React.Fragment>
                }

            </List>
        );
    }
}

const Styled = withStyles(LocationPanel,styles);
export default Styled;
